import Vue from 'vue';
import Router from 'vue-router';

// Components
import Main from '@/views/Layout/Main';
import Login from '@/views/Login/LoginForm';
import ForgotPassword from '@/views/ForgotPassword';
import NotFound from '@/views/NotFound';

// Nested routes.
import nestedRoutes from './nested-routes';

Vue.use(Router);

let router = new Router({
  routes: [
    {
      path: '/',
      name: 'Main',
      component: Main,
      children: nestedRoutes,
      redirect: '/dashboard',
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/login',
      name: 'Login',
      component: Login,
      meta: {
        guest: true
      }
    },
    {
      path: '/forgot-password',
      name: 'ForgotPassword',
      component: ForgotPassword,
      meta: {
        guest: true
      }
    },
    {
      path: '/not-found',
      name: 'NotFound',
      component: NotFound,
      meta: {
        guest: true
      }
    },
  ],
  mode: 'history'
});

/**
 * Authentication.
 */
router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    (localStorage.getItem('token') === null) ? next({name: 'Login', replace: true}) : next();
  } else if (to.matched.some(record => record.meta.guest)) {
    (localStorage.getItem('token') === null) ? next() : next({name: 'FCFSList'})
  } else {
    if (to.path === '/logout') {
      localStorage.removeItem('token');
      next({name: 'Login', replace: true});
    } else {
      next();
    }
  }
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js